import { useMsal } from '@azure/msal-react';
import Button from '@ingka/button';
import { loginRequest } from '../../authConfig';

export const LoginButton = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance
            .loginRedirect({
                ...loginRequest,
                prompt: 'create',
            })
            .catch((error: unknown) => console.log(error));
    };

    return (
        <Button
            type='primary'
            onClick={handleLogin}>
            Log in
        </Button>
    );
}